import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GenericSnackBarComponent } from '@r1-compass-library/components/snack-bars/generic/generic-snack-bar.component';
import { HttpErrorSnackBarComponent } from '@r1-compass-library/components/snack-bars/http-error/http-error-snack-bar.component';
import {
    ErrorSnackBarClass,
    ErrorSnackBarData,
    ErrorSnackBarOptions,
    GenericSnackBarClass,
    GenericSnackBarData,
    GenericSnackBarOptions,
} from '@r1-compass-library/models/snack-bar/snack-bar.model';
import { RequiredFields } from '@r1-compass-library/utilities';

@Injectable({
    providedIn: 'root',
})
export class SnackBarService {
    readonly #snackBar = inject(MatSnackBar);

    openGenericSnackbar(options: GenericSnackBarOptions) {
        const panelClass: GenericSnackBarClass = options.panelClass ?? 'generic-snack-bar-success';
        const duration: number = options.duration ?? 1000;
        const messages: string[] = options.messages ? [...options.messages] : [];
        const expandMessages: string[] = options.expandMessages ? [...options.expandMessages] : [];
        const showDismissButton = !!options.showDismissButton;
        const showExpandButton = !!options.showExpandButton;
        const verticalPosition = options.verticalPosition ?? 'bottom';

        return this.#snackBar.openFromComponent<GenericSnackBarComponent, GenericSnackBarData>(
            GenericSnackBarComponent,
            {
                panelClass: [panelClass],
                duration: panelClass === 'generic-snack-bar-success' ? duration : undefined,
                verticalPosition: verticalPosition,
                data: {
                    messages: messages,
                    expandMessages: expandMessages,
                    showDismissButton: showDismissButton,
                    showExpandButton: showExpandButton,
                    action: options.action,
                    actionText: options.actionText,
                },
            }
        );
    }

    openErrorSnackbar(
        options: RequiredFields<
            ErrorSnackBarOptions,
            'statusCode' | 'statusText' | 'messages' | 'expandMessages' | 'showDismissButton' | 'showExpandButton'
        >
    ) {
        const panelClass: ErrorSnackBarClass = options.panelClass ?? 'error-handling-orange';
        const duration: number = options.duration ?? -1;

        this.#snackBar.openFromComponent<HttpErrorSnackBarComponent, ErrorSnackBarData>(HttpErrorSnackBarComponent, {
            panelClass: [panelClass],
            duration: duration,
            verticalPosition: 'top',
            data: {
                statusCode: options.statusCode,
                statusText: options.statusText,
                messages: options.messages,
                expandMessages: options.expandMessages,
                showDismissButton: options.showDismissButton,
                showExpandButton: options.showExpandButton,
            },
        });
    }
}
